export default function matchOdds(api){
    api.provideOMFETopic('subscribeToSingleOdds', 'unsubscribeFromSingleOdds', {
        topicName : ({ucsOperatorId, apiVersion, lang, oddsId}) =>
            `/sports/${(apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/') || ''}${lang || 'en'}/odd/${oddsId || 0}`,
    });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/sub-single-odds.js